import { useContext } from 'react';

import { HistogramZoomRangesContext } from '../contexts/HistogramZoomRanges.js';

export const useHistogramZoomRanges = () =>
  useContext(HistogramZoomRangesContext);
